import { FC, useMemo } from 'react'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { p11n } from '@ucheba/utils/helpers/string'
import styled, { StyledProps } from 'styled-components'
import { EColorBgText, sv } from '@ucheba/utils/helpers/styles/variables'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { List, ListItem } from '@ucheba/ui/components/List/desktop'
import { Chips } from '@ucheba/ui/components/Chips/desktop'
import { ITimerBannerBlackFriday } from '../types'
import ImgClock from '../assets/img__clock.png'
import ImgBlackFriday from '../assets/img__black-friday_2_desktop.png'
import ImgFireLeft from '../assets/img__fire_left.png'
import ImgFireRight from '../assets/img__fire_right.png'
import ImgList1 from '../assets/img_list-1.png'
import ImgList2 from '../assets/img_list-2.png'
import ImgList5 from '../assets/img_list-5.png'

const Block = styled.div<StyledProps<any>>`
  background-color: ${(props) => sv.color[props.color]};
  display: flex;
  border-radius: 8px;
`

const Content = styled.div`
  flex: 1;
  padding: 32px;
`

const ImgWrap = styled.div`
  width: 470px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`

const Img = styled.img`
  max-width: 470px;
  height: auto;
`

const TimeWrap = styled.div`
  border-radius: 4px;
  overflow: hidden;
  width: 262px;
  display: flex;
  justify-content: space-between;
  color: ${sv.color.black};
`

const TimeBlock = styled.div`
  background-color: white;
  width: 64px;
  padding: 8px 4px;
`

const TimeValue = styled.div`
  font-size: ${sv.fontSize.h1};
  font-weight: ${sv.fontWeight.extrabold};
  text-align: center;
  line-height: 1;
`

const Clock = styled.img`
  width: 86px;
`

const Btn = styled.div<StyledProps<any>>`
  background-color: ${(props) => sv.color[props.color]};
  color: ${(props) => sv.color[EColorBgText[props.color]]};
  padding: 20px;
  border-radius: 4px;
  height: 72px;
  margin-right: 8px;
  cursor: pointer;
`

const ListImg = styled.img`
  width: 24px;
  margin-top: -4px;
`

const ImgFire = styled.img`
  width: 14px;
`

const TimerBannerBlackFriday: FC<ITimerBannerBlackFriday> = (props) => {
  const { seconds, hours, days, minutes, onClick, show, title, subTitle } = props

  const blackFridayContent = useMemo(() => {
    return {
      title: title || 'Подготовка к ЕГЭ по всем предметам по одной цене',
      text:
        subTitle ||
        '<span style="color: #ffe554">51 450 руб.</span> за 7 мес. <span style="color: #ffffff80; text-decoration: line-through">102 900 руб</span>',
      list: [
        {
          img: ImgList1,
          text: 'В подарок консультация по профориентации и подбору вузов',
        },
        {
          img: ImgList2,
          text: '3 дополнительных индивидуальных занятия',
        },
        {
          img: ImgList5,
          text: 'Курс по итоговому сочинению',
        },
      ],
    }
  }, [])

  return (
    <Block color='black'>
      <Content>
        <Grid spacing='xxsmall'>
          <GridCol width='auto'>
            <Chips color='gold'>
              <Text fontWeight='semibold'>Черная пятница</Text>
            </Chips>
          </GridCol>

          <GridCol width='auto'>
            <Chips color='plum'>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <div>
                  <ImgFire src={ImgFireRight} />
                </div>

                <div
                  style={{
                    padding: '0 6px',
                  }}
                >
                  <Text fontWeight='semibold' color='gold'>
                    Скидки 40%!
                  </Text>
                </div>

                <div>
                  <ImgFire src={ImgFireLeft} />
                </div>
              </div>
            </Chips>
          </GridCol>

          <GridCol width='auto'>
            <Chips color='gold'>
              <Text fontWeight='semibold'>С 25 до 30 ноября</Text>
            </Chips>
          </GridCol>
        </Grid>

        <Spacing spacing='small' />

        <Heading h1={blackFridayContent.title} spacing='small' color='white' />

        <>
          <Text color='white' fontSize='h3' fontWeight='bold' lineHeight='h3'>
            {blackFridayContent.text}
          </Text>

          <Spacing spacing='xsmall' />

          <Grid spacing='medium'>
            <GridCol width='auto'>
              <List spacing='xsmall'>
                {blackFridayContent.list.map((item, key) => {
                  return (
                    <ListItem
                      key={key}
                      StartIcon={<ListImg src={item.img} />}
                      alignItems='flex-start'
                    >
                      <Text color='white'>{item.text}</Text>
                    </ListItem>
                  )
                })}
              </List>
            </GridCol>
          </Grid>

          <Spacing spacing='large' />
        </>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {onClick && (
            <Btn onClick={onClick} color='gold'>
              <Text fontSize='h3' lineHeight='h3' fontWeight='semibold'>
                Записаться
              </Text>
            </Btn>
          )}

          {show && (
            <TimeWrap>
              <TimeBlock>
                <TimeValue>{days}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  {p11n(Number(days), 'день', 'дня', 'дней')}
                </Text>
              </TimeBlock>

              <TimeBlock>
                <TimeValue>{hours}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  {p11n(Number(hours), 'час', 'часа', 'часов')}
                </Text>
              </TimeBlock>

              <TimeBlock>
                <TimeValue>{minutes}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  {p11n(Number(minutes), 'минута', 'минуты', 'минут')}
                </Text>
              </TimeBlock>

              <TimeBlock>
                <TimeValue>{seconds}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  секунд
                </Text>
              </TimeBlock>
            </TimeWrap>
          )}

          {!onClick && (
            <div>
              <Clock src={ImgClock} />
            </div>
          )}
        </div>
      </Content>

      <ImgWrap>
        <Img src={ImgBlackFriday} />
      </ImgWrap>
    </Block>
  )
}

export default TimerBannerBlackFriday
